import { render } from "./PrinterTable.vue?vue&type=template&id=8be68ac6&scoped=true"
import script from "./PrinterTable.vue?vue&type=script&lang=js"
export * from "./PrinterTable.vue?vue&type=script&lang=js"

import "./PrinterTable.vue?vue&type=style&index=0&id=8be68ac6&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be68ac6"]])

export default __exports__